import BadgeDetailLayout from '@/layouts/BadgeDetail';
import BadgeDetailMembers from '@/screens/BadgeDetail/BadgeDetailMembers';

export default function PrivateTabsEventBadgeBadgeIdIndexRoute() {
  return (
    <BadgeDetailLayout>
      <BadgeDetailMembers />
    </BadgeDetailLayout>
  );
}
